import { Hero } from '../Hero';
import { Features } from '../Features';
import { HowItWorks } from '../HowItWorks';
import { SuccessStories } from '../SuccessStories';
import { Pricing } from '../Pricing';
import { Contact } from '../Contact';
import { Header } from '../Header';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <Header />
      <main className="relative space-y-0 md:space-y-0">
        <Hero />
        <div className="relative z-10">
          <Features />
          <HowItWorks />
          <SuccessStories />
          <Pricing />
          <Contact />
        </div>
      </main>
    </div>
  );
} 